<template>
    <div>
        <!-- Bloqueio Leito Modal -->
        <div class="modal fade" id="bloqueioLeitoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content" v-if="leito">
                    <div class="modal-header">
                        <h5 class="modal-title">Bloquear Leito</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info">
                            {{ leito.search }}
                            <div>
                                <span class="badge" :class="'badge-' + leito.status_leito.color" v-if="leito.status_leito">
                                    {{ leito.status_leito.msg }}
                                </span>
                            </div>
                        </div>

                        <template v-if="!leito.bloqueio">

                            <div class="row">
                                <div class="col col-12">
                                    <az-input
                                        label="Tipo"
                                        type="select"
                                        optionsMode="aql"
                                        service="bloqueio_local_tipos.index"
                                        optionsData="id_bloqueio_local_tipo"
                                        required
                                        :validate="validate"
                                        v-model="tipo" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col col-12">
                                    <az-input
                                        label="Observações"
                                        type="textarea"
                                        rows="3"
                                        v-model="observacoes" />
                                </div>
                            </div>

                        </template>

                        <template v-else>
                            <div v-if="leito.bloqueio.st_observacoes" class="alert alert-info">
                                {{ leito.bloqueio.st_observacoes }}
                            </div>
                        </template>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="atualizar()">
                            {{ leito.bloqueio ? 'Desbloquear' : 'Bloquear' }}
                        </az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() { 
        return { 
            leito: null, 
            tipo: "", 
            observacoes: "", 
            validate: false, 
        }
    },

    components: { 
        AzInput, 
        AzSubmit, 
    },

    methods: { 
        bloquear (leito) { 
            this.validate = false;
            this.tipo = ""; 
            this.observacoes = ""; 
            this.leito = _.cloneDeep(leito);

            $('#bloqueioLeitoModal').modal('show');
        },

        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'internados',
                func: 'bloquear_leito',
                dados: { 
                    id_local: this.leito.id_local,
                    id_bloqueio_local_tipo: this.tipo, 
                    observacoes: this.observacoes, 
                },
                modal: 'bloqueioLeitoModal',
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        }
    }
}
</script>